import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";

import i18n from "@/i18n";

interface State {
    error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
    state: State = { error: null };

    static getDerivedStateFromError(error: Error): State {
        return { error };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        console.error("[promaster]", error, info.componentStack);
    }

    render() {
        if (!this.state.error) {
            return this.props.children;
        }
        return (
            <main className="pm-page">
                <div className="pm-alert pm-alert--danger">
                    <strong>{i18n.t("app.renderFailed")}</strong>
                    <div>{this.state.error.message}</div>
                </div>
                <button className="pm-button" onClick={() => this.setState({ error: null })}>
                    {i18n.t("app.retry")}
                </button>
            </main>
        );
    }
}
